import React from 'react'
import { UnderwritingOffer } from '_gql'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import CreditLineOfferPage from '@sputnik/pages/PostApplicationPages/CreditLineOffersPage/CreditLineOfferPage'
import { URL } from '@sputnik/resources/constants'

const PrepayOfferPage = () => {
  const { formatMessage } = useIntl()

  return (
    <CreditLineOfferPage
      bulletPoints={[
        <FormattedMessage
          key='add-cash'
          defaultMessage='Add cash to your account, which you can adjust or withdraw anytime.'
          id='sputnik.PrepayOfferPage__bvvFAu'
        />,
        <FormattedMessage
          key='make-payments'
          defaultMessage='Make payments using the funds in your account or another funding source.'
          id='sputnik.PrepayOfferPage__/EwNoa'
        />,
        <FormattedMessage
          key='balance-due'
          defaultMessage='Your balance is due in full at the end of each billing cycle.'
          id='sputnik.PrepayOfferPage__8LBAFn'
        />,
        <FormattedMessage
          key='rewards-points'
          defaultMessage='Get minimum 1.5x points on every dollar you spend, with no minimum spend requirement and no billing cycle restrictions.'
          id='sputnik.PrepayOfferPage__wanrQY'
        />,
      ]}
      learnMoreLink={URL.PREPAY_OFFER_LEARN_MORE_LINK}
      marketingImage={{
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-prepay-setup-content.png',
        alt: formatMessage({
          defaultMessage: 'woman in the woods, looking up at the trees',
          id: 'sputnik.PrepayOfferPage__ll3C1R',
        }),
      }}
      title={
        <FormattedMessage
          defaultMessage='Your prepay setup'
          id='sputnik.PrepayOfferPage__ZVYuU+'
        />
      }
      underwritingOfferType={UnderwritingOffer.SECURED_LINE}
    />
  )
}

export default PrepayOfferPage
